export default "__VITE_ASSET__9q79IADh__"